/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Supported sources for the values of a Product Selection Matrix attribute.
 */
export enum ValuesReferenceTypes {
    /**
     * Values are owned by BC item attribute values.
     */
    ValuesFromBC = 10,
}
